// extracted by mini-css-extract-plugin
module.exports = {"tabs_wrapper":"tabs_wrapper--Tabs-components__3dxA9","tabsWrapper":"tabs_wrapper--Tabs-components__3dxA9","scrollable":"scrollable--Tabs-components__2yiGA"};